/**
 * Универсальный файл, содержащий все необходимые для работы сайта скрипты. Можно использовать на любой странице
 */

import { BREAKPOINTS, IMAGE_URL_STUB } from "../ApplicationConfig";
import initLazyLoad from "../lazy-load/LazyLoad";
import QuickSearch from '../QuickSearch';
import Submitter from '../form/Submitter';
import StandardValidator from '../form/Validator';
import MainMenu from '../menu/MainMenu';
import StyledSelect from "../StyledSelect";
import Filter from "../Filter";
import { listenResizeEvent } from "../ResizeEventListener";
import tabAccordion from "../TabAccordion";
import DelayedCall from "../DelayedCall";
import Accordion, { expandAccordionByHash } from "../Accordion";
import initDelayedRender from "../DelayedRender";
import initMainPage from "../MainPage";
import { leftMenuAnalytics, sendAnalyticsByClick, sendGoogle } from "../Analytics";
import initCatalog from "../pages/Catalog";
import initStaticPage from "../pages/Static";
import initInlineGallery from "../InlineGallery";
import initProduct from "../pages/Product";
import ApplicationState from "../ApplicationState";
import Tabs from "../Tabs";
import googleRemarketing from "../GoogleRemarketing";
import Gallery from "../gallery/Gallery";
import videoPreview from "../VideoPreview";
import Slider from "../slider/Slider";
import CompareButton from "../CompareButton";
import initContactsPage from "../pages/Contacts";
import initPage404 from "../pages/Page404";
import initComparePage from "../pages/Compare";
import Switcher from "../Switcher";
import initMiniFilter from "../MiniFilter";
import initTapBar from "../TapBar";
import { Scroller } from "../Scroller";
import initDefaultModalFormLoader from "../modal/DefaultModalFormLoader";
import Tags from "../Tags";
import initRelink from "../Relink";
import initLinkEmulator from "../LinkEmulator";
import PopupController from "../popup/PopupController";
import Expander from "../Expander";
import DOMElementNotFoundError from "../error/DOMElementNotFoundError";

export default function initApplication() {
    listenResizeEvent();
    leftMenuAnalytics(); // аналитика для левого меню
    tabAccordion(); // связка табы + аккордеон
    initLazyLoad('.ll'); // загрузка основных изображений (для темы - хедер, футер, меню)
    initDelayedRender(); // отложенный рендер блоков
    sendAnalyticsByClick('.js-metrics-by-click'); // события по клику
    googleRemarketing();
    initCatalog();
    initStaticPage();
    initProduct();
    initContactsPage();
    initInlineGallery('#product-card-gallery');
    initPage404();
    expandAccordionByHash('accordion-.+');
    initMiniFilter();
    initTapBar();
    initDefaultModalFormLoader('.js-load-modal');
    initRelink();
    initLinkEmulator('.js-link-emulator', true, 10);
    
    if (window.location.pathname.search(/^\/compare\//) !== -1) {
        initComparePage();
    }

    // аккордеоны
    new Accordion('.js-accordion').init();

    // отложенная загрузка изображений (для контента)
    new DelayedCall().execute(initLazyLoad, 2500, null, '.dll');

    // функции верхнего меню
     new MainMenu('navigation', 'js-toggle-menu').init();

    // поиск в шапке
    new QuickSearch('.js-quick-search', '/catalog/autocomplete_search/').init();

    // стилизованный select
    new StyledSelect('.js-styled-select').init();
    
    // функционал фильтра
    new Filter('.js-filter-form-wrapper').init();

    new Scroller('.js-scroller');

    new CompareButton('.js-action-compare').init();
    
    document.querySelectorAll('.js-switcher').forEach(switcher => new Switcher(switcher));
    document.querySelectorAll('.js-tags').forEach(cloud => new Tags(cloud));

    // подсказки на карточке и других страницах
    try {
        let hint = new PopupController('.js-specification-popup-hint', '.js-hint-container');
        console.log(hint);
        hint.init();
    } catch (e) {
        if (!(e instanceof DOMElementNotFoundError)) {
            throw e;
        }
    }

    document.addEventListener('tabs.after.switch', evt => {
        let e = evt as CustomEvent;
        console.log(e);
    });
    document.querySelectorAll('.js-relink-expander').forEach(node => {
        let item = node as HTMLElement;
        let relinkExpander = new Expander(item);
    });

    // аккордеон для фильтра
    let filterAccordionNode = document.querySelector('.js-filter-accordion') as HTMLElement;
    if (filterAccordionNode !== null) {
        let filterAccordion = new Accordion('.js-filter-accordion');
        
        filterAccordion.init();
        let filterAccordionBodies = filterAccordion.getBodyForControl(filterAccordionNode);
        filterAccordionBodies.forEach(item => {
            let body = item as HTMLElement;
            filterAccordion.adaptHeight(body);
        });
    }

    // главная страница
    if (window.location.pathname === '/' || window.location.pathname === '/main/rework' || window.location.pathname === '/main/rework/') {
        initMainPage(ApplicationState.modal);
    }

    // общий вариант галереи
    document.querySelectorAll('.js-popup-gallery').forEach(item => {
        let key = item.getAttribute('data-gallery-name');
        let gallery = new Gallery(key, item);
    });
}
